"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.livaNovaTheme = exports.epsyTheme = void 0;
var breakpoints_1 = require("./breakpoints");
var colors_1 = require("./colors");
var fonts_1 = require("./fonts");
var shadows_1 = require("./shadows");
exports.epsyTheme = {
    mode: "Epsy",
    breakpoints: breakpoints_1.breakpoints,
    colors: colors_1.epsyColors,
    oldColors: colors_1.oldEpsyColors,
    fonts: fonts_1.epsyFonts,
    shadows: shadows_1.shadows
};
exports.livaNovaTheme = {
    mode: "LivaNova",
    breakpoints: breakpoints_1.breakpoints,
    colors: colors_1.livaNovaColors,
    oldColors: colors_1.oldLivaNovaColors,
    fonts: fonts_1.livaNovaFonts,
    shadows: shadows_1.shadows
};
